module.exports = __webpack_public_path__ + "img/Neopark_EN.6f059b2c.jpg";